import { parseISO, isValid, isToday, isYesterday } from 'date-fns';

const timeFormatter = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
});

const getSafeIsoString = (dateInput?: string | Date | null): string | null => {
    if (!dateInput) return null;
    if (typeof dateInput === 'string') return dateInput;
    if (dateInput instanceof Date) return dateInput.toISOString();
    return null;
};

export const formatMessageTime = (dateInput?: string | Date | null): string => {
    const dateString = getSafeIsoString(dateInput);
    if (!dateString) return '';

    const parsedDate = parseISO(dateString);
    if (!isValid(parsedDate)) return '';

    return timeFormatter.format(parsedDate);
};

export const formatSeparatorDate = (dateInput?: string | Date | null): string => {
    const dateString = getSafeIsoString(dateInput);
    if (!dateString) return '';

    const parsedDate = parseISO(dateString);
    if (!isValid(parsedDate)) return '';

    const timeString = timeFormatter.format(parsedDate);

    if (isToday(parsedDate)) {
        return `Hoy ${timeString}`;
    }
    if (isYesterday(parsedDate)) {
        return `Ayer ${timeString}`;
    }

    return dateFormatter.format(parsedDate);
};
